export class PCHAlert {
    public time: number; // timestamp
    public title: string;
    public message: string;
    public id: string;
}
